export function URL() {
  if (process.env.NODE_ENV === "development") {
    return "https://localhost:44365/api/";
  } else {
    return "https://vulekamalibulletinapi.treasury.gov.za/api/";
  }
}

export function URLHTMLBuilder() {
  if (process.env.NODE_ENV === "development") {
    return "https://localhost:3000";
  } else {
    return "http://10.126.154.54:7000";
  }
}
